<div class="spinner">
  <mat-spinner></mat-spinner>
  <span>Aguarde, efetuando cadastro</span>
</div>